'use strict';

angular.module('cgmemApp')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
			.state('authenticated.editmember', {
        url: '/profile/editmember?memberId',
        templateUrl: 'app/editMembers/editMembers.html',
        controller: 'EditMemberCtrl',
      });
  }]);